import {
  GoalPosition,
  PitchDistance,
  PitchPosition,
} from '@collector/mobile-feature-goal-and-pitch-positions'
import {
  HandballAttributeId,
  HandballGoalAttribute,
} from '@collector/sportsapi-client-legacy'

export const pitchDistanceAttributeMap = new Map<
  PitchDistance,
  HandballAttributeId
>([
  ['6m', HandballGoalAttribute.SixMeter],
  ['9m', HandballGoalAttribute.NineMeter],
])

export const pitchPositionAttributeMap = new Map<
  PitchPosition,
  HandballAttributeId
>([
  ['left', HandballGoalAttribute.LeftSide],
  ['right', HandballGoalAttribute.RightSide],
  ['left-wing', HandballGoalAttribute.LeftWing],
  ['right-wing', HandballGoalAttribute.RightWing],
  ['center', HandballGoalAttribute.Center],
])

export const goalPositionAttributeMap = new Map<
  GoalPosition,
  HandballAttributeId
>([
  ['upper-left', HandballGoalAttribute.UpperLeft],
  ['upper-right', HandballGoalAttribute.UpperRight],
  ['upper-middle', HandballGoalAttribute.UpperMiddle],
  ['bottom-left', HandballGoalAttribute.BottomLeft],
  ['bottom-right', HandballGoalAttribute.BottomRight],
  ['bottom-middle', HandballGoalAttribute.BottomMiddle],
])
